<ng-container *ngIf="!success">

  <div class="form-input top-text">
    {{getString('newCardDealText')}}
  </div>

  <div class="form-input">
    <label>{{getString('deliveryType')}}*</label>
    <app-custom-checkbox [value]="deliveryTypeEmail" [label]="getString('codeByEmail')" (onChange)="deliveryTypeEmail = $event"></app-custom-checkbox>
    <app-custom-checkbox [value]="deliveryTypeRetail" [label]="getString('physicalCard')" (onChange)="deliveryTypeRetail = $event"></app-custom-checkbox>
    <div class="red-text" *ngIf="!deliveryTypeChosen">{{getString('pleaseSelectADeliveryType')}}</div>
  </div>

  <div class="form-input">
    <label for="cardValueSelect">{{getString('cardValue')}}*</label>
    <select id="cardValueSelect" [(ngModel)]="cardValue" (change)="cardValueChange($event)">
      <option *ngFor="let cV of cardValues" [value]="cV.value">{{cV.label}}</option>
    </select>
  </div>

  <div class="form-input">
    <label for="priceInput">{{getString('price')}}</label>
    <input id="priceInput" type="number" [(ngModel)]="price" [disabled]="priceDisabled">
    <img class="info-icon" src="./assets/images/info.png" alt="info" [title]="getString('newCardDealInfoPrice')">
  </div>

  <div class="form-input">
    <label for="sourceInput">{{getString('source')}}*</label>
    <input id="sourceInput" type="text" [(ngModel)]="source" [class.invalid]="invalidSource">
    <img class="info-icon" src="./assets/images/info.png" alt="info" [title]="getString('newCardDealInfoSource')">
  </div>

  <div class="form-input">
    <label for="linkInput">{{getString('link')}}*</label>
    <input id="linkInput" type="text" [(ngModel)]="link" [class.invalid]="invalidLink">
    <img class="info-icon" src="./assets/images/info.png" alt="info" [title]="getString('newCardDealInfoLink')">
  </div>

  <div class="form-input">
    <label for="titleInput">{{getString('title')}}*</label>
    <input id="titleInput" type="text" [(ngModel)]="title">
  </div>

  <div class="form-input">
    <label>{{getString('notes')}}</label>
    <textarea [(ngModel)]="notes"></textarea>
  </div>

  <div class="red-text" *ngIf="incompleteForm">· {{getString('formIsIncomplete')}}</div>
  <div class="red-text" *ngIf="error">· {{getString('serverError')}}</div>
  <div class="red-text" *ngIf=invalidSource>· {{getString('invalidSource')}}</div>
  <div class="red-text" *ngIf=invalidLink>· {{getString('newCardDealInfoLink')}}</div>

  <div class="btn-container">
    <button type="button" class="cancel-btn" (click)="cancel()">{{getString('cancel')}}</button>
    <button type="button" class="blue-button" (click)="submit()">{{getString('submit')}}</button>
  </div>

</ng-container>

<div class="success-container" *ngIf="success === true">

  <img class="success-check" src="./assets/images/blue_check_icon.png">
  <div>{{getString('thankYou')}}</div>
  <div>{{getString('newDealSuccessText')}}</div>
  <button class="blue-button close-btn" type="button" (click)="close()">{{getString('close')}}</button>

</div>

